module.exports = __webpack_public_path__ + "img/410.5b95b8c2.png";